import FeePaymentMethod from './FeePaymentMethod';

export default FeePaymentMethod;
